import { render, staticRenderFns } from "./ScenarioTemplateItem.vue?vue&type=template&id=9cd1545a&scoped=true&"
import script from "./ScenarioTemplateItem.vue?vue&type=script&lang=js&"
export * from "./ScenarioTemplateItem.vue?vue&type=script&lang=js&"
import style0 from "../../Style/scenario-template-item.scss?vue&type=style&index=0&id=9cd1545a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cd1545a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Data\\Projects\\Werk\\DPG\\DNX2-DPG\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9cd1545a')) {
      api.createRecord('9cd1545a', component.options)
    } else {
      api.reload('9cd1545a', component.options)
    }
    module.hot.accept("./ScenarioTemplateItem.vue?vue&type=template&id=9cd1545a&scoped=true&", function () {
      api.rerender('9cd1545a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/DmVisualizer/Components/Templates/ScenarioTemplateItem.vue"
export default component.exports